import { Injectable, EventEmitter, TemplateRef } from '@angular/core';
import { Paging } from 'shared/entities/paging.entity';
import { Observable, Subject } from 'rxjs';


@Injectable()

export class NavegacaoPaginaService {
    
    public Titulo: string = null;
    private atualizarTitulo: Subject<string> = new Subject<string>();
    public atualizarTitulo$ = this.atualizarTitulo;

    private alterarSenha: Subject<boolean> = new Subject<boolean>();
    public alterarSenha$ = this.alterarSenha;

    private confirmarInternetBanking: Subject<boolean> = new Subject<boolean>();
    public confirmarInternetBanking$ = this.confirmarInternetBanking;

    public TextoConfirmacao: string=null;

    public AlterarTitulo(titulo: string): void
    {
        this.Titulo = titulo;
        this.atualizarTitulo.next(titulo);
    }

    public AlterarSenha(trocar: boolean): void
    {
        this.alterarSenha.next(trocar);
    }

    public ConfirmarInternetBanking(trocar: boolean): void
    {
        this.confirmarInternetBanking.next(trocar);
    }
}